<script lang="ts" setup>
import type { PropType} from 'vue';
import { computed } from 'vue';
import { Status } from '@/components/common/editors/saveStatus/SaveStatuses';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';

export type BadgeVariant = 'primary' | 'secondary' | 'error' | 'success' | 'warning' | 'purple';

export type BadgeProps = typeof props;
const props = defineProps({
    text: {
        type: [String, Number],
        default: ''
    },
    tooltip: {
        type: String,
        default: ''
    },
    status: {
        type: String as PropType<Status>,
        default: null
    },
    variant: {
        type: String as PropType<BadgeVariant | string>,
        default: 'primary'
    },
    isLight: {
        type: Boolean,
        default: false
    },
    rounded: {
        type: Boolean,
        default: false
    },
    small: {
        type: Boolean,
        default: false
    },
    loading: {
        type: Boolean,
        default: false
    }
});

const badgeVariant = computed(() => {
    switch (props.status) {
        case Status.Error:
            return 'error';
        case Status.Success:
            return 'success';
        case Status.Info:
            return 'primary';
        case Status.Warning:
            return 'warning';
        case Status.Neutral:
            return 'secondary';
        default:
            return props.variant;
    }
});
</script>

<template>
    <span
        v-tooltip="tooltip"
        :class="[
            'sy-group-badge', `sy-${badgeVariant}`,
            {
                'sy-light': isLight,
                'sy-group-badge-rounded': rounded,
                'small': small
            }
        ]"
    >
        <LoadingSpinner v-if="loading" variant="light" size="small"></LoadingSpinner>
        <slot v-else>{{ text }}</slot>

    </span>
</template>
